export const AUTH_REFRESH_FAIL = 'AUTH_REFRESH_FAIL';
